import React, { Component } from "react";
import { translate } from "react-i18next";
import { withRouter } from "react-router-dom";
import compose from "ramda/src/compose";
import { bool, func, string, object } from "prop-types";
import { Modal, Button } from "shared/components";
import styles from "./styles.css";
import iconSuccess from "../../assets/svg/sucesso.svg";
import classNames from "classnames";
import _get from "lodash/get";

class ModalSuccess extends Component {
  goToIncident = () => {
    const { onClose, history } = this.props;
    history.push("/incident-manager");
    onClose();
  };

  handleMsg = () => {
    const { customClass } = this.props;
    const customClassMsg = _get(customClass, "textSuccess");
    const classMsg = classNames({
      [styles.textSuccess]: !customClassMsg,
      [_get(styles, customClassMsg)]: customClassMsg,
    });
    const message = this.props.msg ? this.props.msg : this.props.t("MSG_0115");
    if (this.props.msg2) {
      return (
        <p className={classMsg}>
          <b>{message}</b>
          <br />
          <span>{this.props.msg2}</span>
        </p>
      );
    }
    return <p className={classMsg}>{message}</p>;
  };

  handleProtocol = () => {
    if (this.props.protocol) {
      return (
        <p className={styles.protocol}>Protocolo: {this.props.protocol}</p>
      );
    }
  };

  renderTitle = () => {
    const { title } = this.props;
    if (title) {
      return <p className={styles.modalTitle}>{title}</p>;
    }

    return "";
  };

  renderDivLine = () => {
    const { customClass } = this.props;

    if (_get(customClass, "divLine")) {
      return <div className={styles[_get(customClass, "divLine")]} />;
    }

    return <hr />;
  };

  render() {
    const {
      isOpen,
      onClose,
      icon,
      follow,
      t,
      customClass,
      ctaText,
      ctaFunction,
    } = this.props;
    return (
      <div>
        <Modal isOpen={isOpen} onClose={onClose} ariaHideApp={false}>
          <div className={styles.rootSuccess}>
            <img
              className={styles[_get(customClass, "modalIcon")]}
              src={icon ? icon : iconSuccess}
              alt=""
            />
            {this.renderTitle()}
            {this.handleMsg()}
            {this.handleProtocol()}
            {this.renderDivLine()}
            <div
              className={classNames(
                styles.action,
                styles[_get(customClass, "ctaButton", "")]
              )}
            >
              {follow ? (
                <Button
                  onClick={this.goToIncident}
                  relevance="normal"
                  toLinkBtn
                >
                  {t("MSG_0191")}
                </Button>
              ) : null}
              <Button
                onClick={ctaFunction ? ctaFunction : onClose}
                relevance="normal"
                callToAction
              >
                {ctaText ? ctaText : t("MSG_0111")}
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

ModalSuccess.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  protocol: string,
  customClass: object,
  title: string,
  ctaFunction: func,
};

ModalSuccess.defaultPropTypes = {
  protocol: "",
};

const enhance = compose(withRouter, translate());

export default enhance(ModalSuccess);



// WEBPACK FOOTER //
// ./src/components/ModalSuccess/index.js